import ScheduleNavItem from './ScheduleNavItem';

export default ScheduleNavItem;
